export function getInputValue(inputs, name) {
  return name in inputs ? inputs[name] : null;
}

export function filterInputWith(inputs, search) {
  const prefixes = search.split('|');
  return Object.keys(inputs).filter(name => (
    prefixes.some(prefix => name.startsWith(prefix))
  ));
}

export function getInputWith(inputs, search) {
  return filterInputWith(inputs, search)
    .reduce((acc, name) => {
      acc[name] = inputs[name];
      return acc;
    }, {});
}

export function hasFilledInputWith(inputs, search) {
  return filterInputWith(inputs, search)
    .map(name => getInputValue(inputs, name))
    .filter(value => !!value)
    .length >= 1;
}

export function useInputs(inputs = {}) {
  return {
    inputs,
    getValue(name) {
      return getInputValue(inputs, name);
    },
    getWith(search) {
      return getInputWith(inputs, search);
    },
    hasFilledWith(search) {
      return hasFilledInputWith(inputs, search);
    },
  };
}
